import Client from '../HttpClient';

import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const getPolicy = (systemSource, merchantId) => {
	return Client.get(
		systemSourceUrl(systemSource, `/api/vs/manage/${merchantId}/merchantPolicy`)
	);
};

const postPolicy = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage/${merchantId}/merchantPolicy`
		),
		data
	);
};

const delPolicy = (systemSource, merchantId, id) => {
	return Client.del(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage/${merchantId}/merchantPolicy/${id}`
		)
	);
};

const activePolicy = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage/${merchantId}/merchantPolicy/activeOrNo`
		),
		data
	);
};

export default {
	getPolicy,
	postPolicy,
	delPolicy,
	activePolicy,
};
